










































































































    import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
    import {Debounce} from "vue-debounce-decorator";
    import {SessionDataHelper} from "./helpers/SessionDataHelper";
    import Comments from '../comments/components/Comments.vue';
    import {isWebinarNow, isComingSoon, secondsBeforeMoment, isFinished, isLiveByTime, haveTimeJoint } from "@common/webinarHelper";
    import { dateInOriginalOffset } from "@common/dateTimeHelper";
    import {EventBus} from "@common/EventBus";
    import Vue from 'vue';
    import {UserProfile} from "@api/models/UserProfile";

    import BounceSpinner from "../common/BounceSpinner.vue";
    import PeriodicRefreshMixin from "@mixins/PeriodicRefreshMixin";
    import AnalyticsMixin from "@mixins/AnalyticsMixin";
    import { livePlyr, videoPlyr } from "@common/plyrHelper";
    import {WebinarInfo} from "@api/models/WebinarInfo";
    import { WebinarInfoCustom } from '@api/models/interfaces/WebinatInfoInterface';
    import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
    import {DateTime} from "luxon";
    import { Element as ElementModel } from "@api/models/Element";
    import InfoPanel from "../info-panel/InfoPanel.vue";

    import ObjectLayout, { SwitchersTypes } from "@service/layouts/ObjectViewLayout.vue";

    import { ProgramDataHelper } from '@share/program/helpers/ProgramDataHelper';
    import { EventInfoData } from "../program/types/EventInfoData"
    import WebConference from "@share/web-conferences/WebConference.vue";
    import PeopleManagement from "@share/web-conferences/components/people/PeopleManagement.vue";
    import ContactsAgreement from "@share/common/contacts-agreement/ContactsAgreement.vue";
    import E404 from "@service/views/errors/e404.vue";

    import SessionInfo from "./components/session-info/SessionInfo.vue"
    import Likes from "../common/Likes.vue";
    import {
        SignalRMethod,
        RealtimeCallback,
        RealtimeMessageModel,
        Observers
    } from "@api/repositories/reatime-repository/types";

    import { MiniPlayerParams } from '@service/store/types/MiniPlayerState';
    import { BackgroundViewHelper } from '@service/components/background-view/BackgroundViewHelper/BackgroundViewHelper';
    import { BackgroundViewName } from '@service/components/background-view/types/BackgroundViewName';
    import ComingSoon from "./components/coming-soon/ComingSoon.vue";
    import ObjectSidebar from "@share/object-sidebar/ObjectSidebar.vue";
    import { RouteNamesEnum } from '@service/router/RouteNamesEnum';
    import { getPaddingForCorrectRatio } from '@common/aspectRatioHelper';
    import { getMessageObjectIfSuccess } from '@api/helpers/realtimeMessageHandlers';
    import { EventInterface } from '@share/program/types/EventInterface';
	import { getYouTubeUrl } from '@common/urlHelper';
    import { COMINGSOON_PERIOD_IN_MINUTES } from '@common/constants';
    import { WebConferenceState } from '@share/web-conferences/store/WebConferenceState';
    import { detectMob } from '@common/mobileHelper';
    import {getIgnoreCase} from "@common/ObjectsHelper";
    import {RepositoryFabric} from "@api/repositories/RepositoryFabric";

    import { SessionManipulationService, SessionManipulationServiceInterface } from "@share/session/helpers/SessionManipulationService";

    @Component({
        name: 'Session',
        components: {
          ObjectSidebar,
          PeopleManagement, ComingSoon,
          WebConference, ObjectLayout, InfoPanel, ContactsAgreement,
          BounceSpinner, Comments, SessionInfo, E404 },
    })
    export default class Session extends Mixins(PeriodicRefreshMixin, AnalyticsMixin) {
        @Prop({required: false, default: null}) programDataHelper: ProgramDataHelper | null;
        @Prop({required: false, default: null}) eventId: string | null;

        @Prop({required: true}) sessionId: string;
        @Prop({ required: true }) backgroundViewName: BackgroundViewName;
        @Prop({ default: false }) hideSidebar: boolean;
        @Prop({ default: false }) hideInfoPanel: boolean;
        @Prop({ default: false }) hideSessionInfo: boolean;

        SESSION_ACTIVATE_LIMIT_TIMEOUT = 59 * 1000;

        agendaSchemaId  = process.env.VUE_APP_AGENDA_SCHEMA!;

        dataHelper: SessionDataHelper | null = null;
        isLoading = true;
        isTheater = false;
        showComingsoonForRedirect = false;
        plyr: any = null;
        playerResizeObserver: ResizeObserver | null = null;
        playerWidth = '';
        fixPlayerHeight = false;
        iframeDestroyed = false;

        useRealtimeUpdates = true;

        realtimeSessionUpdateCallback: RealtimeCallback | null = null;
        realtimeLikesUpdateCallback: RealtimeCallback | null = null;
        prevSessionId = "";
        showContactsArgreement = true;

        /**
         * после ручного завершения переводить всех на сцену или включать сценарий doAfterSession
         */
        allToStage = false;
        commentsMustShown = false;

        sessionManipulationService: SessionManipulationServiceInterface | null = null;

        created() {
            if(this.isAdmin) {
                this.sessionManipulationService = new SessionManipulationService(
                    this.agendaSchemaId,
                    this.$repositories.get(RepositoryFabric.OBJECT)
                );
            }

        }

        async mounted() {
            this.dataHelper = Vue.observable(new SessionDataHelper(this.$repositories, this.$store, this.agendaSchemaId));
            await this.loadSessionData();

            this.loaded();

            if(this.useRealtimeUpdates) {
                this.connectToHub();
            }

            this.initVideoRefresh();

            if (!this.isComingSoon || this.isSpeakerOrAdmin || this.element?.isManualControlled) {
                this.subscribe(); // NOTE: deprecated now
                this.initializeVideo();
            }

            this.setResizeObserver();

            this.updateCommetsVisibility();
        }

        onSidebarVisibilityChange({ type, state }: { type: SwitchersTypes; state: boolean }) {
            if(type === "mobile" && !state) {
                this.commentsMustShown = true;
            }
        }

        @Watch('sessionId')
        async onSessionIdChanged(newValue: string, oldValue: string) {
            if (this.dataHelper) {
                this.isLoading = true;
                this.disconnectFromHub();
                try {
                    this.prevSessionId = oldValue;
                    await this.loadSessionData();
                    this.onActivate();
                    this.loaded();
                    this.connectToHub();
                }
                catch (e) {
                    this.$store.dispatch('reportException', e, {root: true});
                }
                finally {
                    this.isLoading = false;
                }
            }
        }

        @Watch("routeName")
        watchRouteName() {
            if(this.$route.name === RouteNamesEnum.viewSession) {
                this.sendAnalytics(this.dataHelper?.element);
            }
        }

        /**
         * starts timer for count before doing redirect to next session
         */
        startRedirect() {
            this.showComingsoonForRedirect = true;
        }

        doRedirect() {

            this.showComingsoonForRedirect = false;
            this.$store.dispatch("backgroundView/setOffline", BackgroundViewName.session);

            if(this.nextSession && !this.allToStage) {
                this.moveToSessionById(this.nextSession.id);
            }
            else {
                this.$emit("close");
            }

            this.allToStage = false;
        }

        moveToSessionById(id: string) {
            this.$router.push({
                name: "ViewSession",
                params: {
                    backend: this.$route.params.backend,
                    eventId: this.eventId ?? "",
                    id: id
                }
            });
        }

        moveToHome() {
            this.$router.push({
                name: "Home",
                params: {
                    backend: this.$route.params.backend,
                }
            });
        }

        getObservers(lang = this.lang): Observers {
            return {
                ['object.Agenda.' + this.objectId + '.' + lang]: {
                    [SignalRMethod.objectUpdated]: this.sessionRealtimeUpdate,
                    [SignalRMethod.objectLikesUpdated]: this.realtimeLikesUpdate
                }
            }
        }

        connectToHub(lang = this.lang) {
            if(this.dataHelper) {
                try {
                    this.dataHelper.attachToRealtimeUpdate(this.getObservers(lang));
                }
                catch(e) {
                    this.$store.dispatch('reportError', e);
                }
            }
        }

        disconnectFromHub(lang = this.lang) {
            try {
                this.dataHelper?.detachFromRealtimeUpdate(this.getObservers(lang));
            }
            catch(e) {
                this.$store.dispatch('reportError', e);
            }
        }

        /**
         * Обновление сессий в списке и расписании при обновлении
         * в реальном времени
         */
        private sessionRealtimeUpdate(message: string | object) {
            const messageObject: RealtimeMessageModel | null = getMessageObjectIfSuccess(message);

            if(!messageObject) {
                return;
            }

            const { data, schemaId } = messageObject;

            if (data && schemaId && this.dataHelper) {
                this.updateElementPartially(data)
            }
        }

        private realtimeLikesUpdate(message: string) {
            const messageObject: RealtimeMessageModel | null = getMessageObjectIfSuccess(message);

            if(!messageObject) {
                return;
            }

            const { likes } = messageObject;

            if(likes?.count !== this.likes?.count && this.dataHelper) {
                Vue.set(this.dataHelper.likes, 'rating', likes?.rating || null);
                Vue.set(this.dataHelper.likes, 'count', likes?.count || null);
            }
        }

        updateElementPartially(data: any) {
            //ISCLOSED:
            if(data.isClosed !== this.element?.isClosed) {

                const delay = this.isAdmin ? 0 : Math.round((Math.random() * 3000));

                setTimeout(() => {
                    this.dataHelper?.updateIsClosed(data.isClosed);
                    if(!(data.isClosed === true)) {
                        !this.isSpeakerOrAdmin && this.reinitVideo();
                    }
                    else {
                        if(this.allToStage) {
                            this.startRedirect();
                        }
                        else {
                            this.doAfterSession();
                        }
                    }
                }, delay)
            }

            //ISSTARTED:
            if (data.isStarted !== this.element?.isStarted) {
                this.dataHelper?.updateIsStarted(data.isStarted);
                this.reinitVideo();
            }

            //ISMANUALCONTROL:
            if (data.isManualControlled !== this.element?.isManualControlled) {
                this.dataHelper?.updateIsManualControlledLocal(data.isManualControlled);
            }

            //BEGIN:
            if (data.beginAt !== this.element?.beginAt.toISO()) {
                this.dataHelper?.updateBeginAt(DateTime.fromISO(data.beginAt))
            }

            //END:
            if (data.endAt !== this.element?.endAt.toISO()) {
                this.dataHelper?.updateEndAt(DateTime.fromISO(data.endAt))
            }
        }

        onActivate() {
            if (this.isComingSoon) {
                return
            }
            this.reinitVideo();
            this.setResizeObserver();
        }

        setResizeObserver() {
            const video = this.$refs['video'] as Element;
            if(video && ResizeObserver) {
                this.playerResizeObserver = new ResizeObserver(this.resizeHandler);
                this.playerResizeObserver.observe(video);
            }
            else if(!video) {
                window.addEventListener("resize", this.updateCommetsVisibility)
            }
        }

        beforeDestroy() {
            this.unsubscribe();
            this.playerResizeObserver?.disconnect();
            window.removeEventListener("resize", this.updateCommetsVisibility);
        }

        subscribe() {
            EventBus.$on('update-session-likes', this.updateLikeFromAgenda);
        }

        unsubscribe() {
            EventBus.$off('update-session-likes', this.updateLikeFromAgenda);
        }

        async updateLikeFromAgenda(data: any) {
            await this.likeChanged(data.value);

            const likesRef = this.$refs.likes as Likes;

            if(likesRef) {
                likesRef.onAmountChange();
            }
        }

        /**
         * Перематывает видео вперед или назад на количество секунд
         *  прошедших от начала сессии
         * @action - действие определяющее напрвление
         */
        rewindByDerection(action: 'rewind' | 'forward') {
            return () => {
                const seconds = Math.abs(secondsBeforeMoment(this.element?.beginAt));
                if (this.plyr.duration > seconds) {
                    this.plyr[action](seconds);
                }
            }
        }

        initializeVideo() {
            if (!this.isCustom && this.isNowAndNotLoading) {
                this.$nextTick(() => {
                    if (this.$refs['video']) {

                        const plyrConstructor = this.isPastSessionRecord ? videoPlyr : livePlyr;
                        this.plyr = plyrConstructor(this.$refs['video'] as HTMLElement);
                        this.plyr.on('ready', () => { this.keepVideoRation() });

                        /// Для трансляций из заранее записаного видео на youtube нужно
                        // синхронизировать текущий момент с временем начала сессии
                        if(this.isYouTubeRecord) {
                            this.plyr.on("play", this.rewindByDerection('forward'));
                            this.plyr.on("pause", this.rewindByDerection('rewind'));
                        }

                        // Длѝ онлайн-траѝлѝций нужно поѝле паузы проматывать к текущему моменту
                        this.isYouTube && this.plyr.on("play", () => {
                            if (!this.plyr.fullscreen.active) {
                                this.plyr.stop();
                                this.plyr.play();
                            }
                        });
                    }
                })
            }
        }

        setVideoController() {
            const params: MiniPlayerParams = {
                object: this.element || null,
                returnRouteName: RouteNamesEnum.viewSession || "Home"
            }

            this.$emit('videoInited', params);
        }

        /**
         * Проверка изменения url трансляции
         */
        initVideoRefresh(): void {
            this.initRefresh(async () => {

                if(this.isNowAndNotLoading || this.isComingSoon) {
                    const urlBeforeUpdate = this.streamIframeSettings.url;

                    //remove
                    await this.dataHelper?.setObjectId(this.sessionId);
                    await this.dataHelper?.fetchWebinarInfo();

                    const urlAfterUpdate = this.streamIframeSettings.url;

                    const hasChanges = urlBeforeUpdate !== urlAfterUpdate

                    if(hasChanges) {
                        this.reinitVideo()
                    }
                }

                //SessionTimeWatcher
            }, this.SESSION_ACTIVATE_LIMIT_TIMEOUT, null, null);
        }

        /**
         * Переинициализирует видео
         */
        reinitVideo() {
            //изменение флага isLoading нужно для того-что бы iframe пересоздался
            this.isLoading = true;
            this.$nextTick(() => {
                this.isLoading = false;
                this.initializeVideo();
            })
        }

        get eventInfoData(): EventInfoData {
            return {
                speakers: this.programDataHelper?.eventSpeakers?.[this.eventId || ''] || [],
                partners: [],
                previewObject: this.dataHelper?.element
            }
        }

        get sessionList(): EventInterface[] {
            return this.programDataHelper?.agendaResource || [];
        }

        get nextSession(): EventInterface | undefined {

            //если есть стык по времени или сессия live
            const filteredSessions = this.sessionList
            .sort((a: EventInterface, b: EventInterface) => a.beginAt.toMillis() - b.beginAt.toMillis())
            .filter((session) => {
                return (haveTimeJoint(this.element?.endAt, session.beginAt) || isLiveByTime(session.beginAt, session.endAt))
                    && this.element?.id !== session.id ;
            });

            if(filteredSessions.length === 1) {
                return filteredSessions[0];
            }
            else {
                return undefined;
            }
        }

        get sessionBeginAt() {
            return this.dataHelper?.element?.beginAt;
        }

        /**
         * использование счетчика general для списка пользователей онлайн
         */
        get useGeneralCouterForUsersWatching() {
            return this.$store.getters['events/selectedEventViewParam']('usersWatchingPanel', null)?.showGenerallyAllUsersForSession;
        }

        get onlineUsersCounterId() {
            return 'sessions/' + this.sessionId;
        }

        get element() {
            return this.dataHelper?.element;
        }

        get likes() {
            return this.dataHelper?.likes;
        }

        get commentsCount() {
            return this.dataHelper?.commentsCount;
        }

        get speakers() {
            return this.dataHelper?.speakers || [];
        }

        get isSpeaker() {
            return this.speakers?.findIndex(item => item.userId == this.$store.getters.profile?.userId) >= 0;
        }

        get objectId() {
            return this.dataHelper?.objectId;
        }

        get webinarInfo(): WebinarInfo {
            return this.dataHelper?.webinarInfo || ({} as WebinarInfo);
        }

        get videoId() {
            return 'video_' + this.element?.id
        }

        get onlineProvider() {
          return this.dataHelper?.webinarInfo?.onlineProvider;
        }

        get isProviderForIframe() {
            return !this.isWebConf && this.streamIframeSettings.url && !this.iframeDestroyed
        }

        get isWebConf() {
            return [OnlineProvider.webConference, OnlineProvider.agora, OnlineProvider.liveKit].indexOf(this.onlineProvider as any) >= 0;
        }

        // признак предѝтоѝщей ѝеѝѝии (длѝ нее будет показыватьѝѝ времѝ до начала)
        get isComingSoon() {
            if (this.isLoading || (this.isStarted && this.isProviderForIframe)) {
                return false;
            }
            return this.dataHelper?.element &&
                   this.dataHelper?.element.beginAt &&
                   this.dataHelper?.element.endAt &&
                   isComingSoon(this.dataHelper?.element.beginAt);
        }


        /**
         * Определяет, активна ли видео-трансляции сейчас (начало сессии > текущее время > окончание + 5 минут)
         * Если сессия имеет флаг isStarted, то она должна идти сейчас для всех вне зависимости от времени
         * Если текущий пользователь админ или спикер то для него сессия тоже должна идти сейчас вне зависимости от флага isStarted и времени
         */
        get isNow() {
            //время не определено
            if(!this.dataHelper?.element?.beginAt || !this.dataHelper?.element.endAt) {return false;}

            return isWebinarNow(this.dataHelper?.element.beginAt, this.dataHelper?.element.endAt) || this.isStarted || this.isSpeakerOrAdmin || this.isPastSessionRecord;
        }

        // Определѝет, активна ли сессия
        get isNowAndNotLoading() {
            if (this.isLoading) {
                return false;
            }
            return this.isNow;
        }

        get isSpeakerOrAdmin() {
            return this.isSpeaker || this.isAdmin
        }

        get sessionIsFinished() {
            return this.isClosed || this.showComingsoonForRedirect || (!this.isNow && !this.isManualControlled && this.isStarted)
        }

        get isClosed(): boolean {
            return this.element?.isClosed === true;
        }

        get isStarted(): boolean {
            return this.element?.isStarted === true;
        }

        get isManualControlled() {
            return this.element?.isManualControlled === true;
        }

        get isFinished() {
            return this.element?.endAt && isFinished(this.element.endAt)
        }

        get isYouTube() {
            return this.webinarInfo && this.webinarInfo.onlineProvider?.toLowerCase() === "youtube";
        }

        get isYouTubeRecord() {
            return this.webinarInfo && this.webinarInfo.onlineProvider?.toLowerCase() === "youtuberecord";
        }

        get isPastSessionRecord() {
            return this.element?.onlineProvider === OnlineProvider.pastSessionRecord
        }

        get isCustom () {
            return this.webinarInfo && this.webinarInfo.onlineProvider?.toLowerCase() === "custom";
        }

        get isAdmin() {
            return this.$store.getters['isAdmin'];
        }

        get showPeopleManagement() {
            return (this.isSpeakerOrAdmin) && this.isWebConf;
        }

        get routeName() {
            return this.$route.name;
        }

        get streamIframeSettings() {
            const settings: WebinarInfoCustom = {
                allow: "",
                url: ""
            }

            if(this.isPastSessionRecord) {
                settings.url = getYouTubeUrl(getIgnoreCase<string>(this.element ?? {}, ['onlineParams', 'pastsessionrecord', 'url'], ''));
                return settings;
            }

            if (this.isYouTube) {
                settings.url = this.webinarInfo.youTube.iframeUrl ?? "";
                return settings;
            }

            if (this.isYouTubeRecord) {
                const url = this.webinarInfo.custom.url ?? "";

                const youTubeUrl = getYouTubeUrl(url);

                if(youTubeUrl) {
                    settings.url = youTubeUrl
                }

                return settings;
            }

            try{
                settings.allow = "microphone; camera; autoplay";
                if (this.isCustom && this.webinarInfo.custom.url) {
                    //Facecast Crutch
                    const url = new URL(this.webinarInfo.custom.url);
                    if(url.host.match(/facecast/)) {
                        url.searchParams.append('autorun', 'auto');
                        url.searchParams.append('nolabel', 'true');
                        url.searchParams.append('css', 'https://static.appercode.com/static/facecast/player.css');
                    }

                    settings.url = url.toString();
                }
            } catch(error) {
                this.$store.dispatch('reportException', error);
            }
            return settings;
        }

        get simulInterpretation(): string {
            return this.webinarInfo?.simulInterpretation?.url ?? '';
        }

        get maxSpeakersNumber() {
            return this.isNow ? 7 : 30;
        }

        get lang() {
            return this.$store.state.session.language || 'en';
        }

        get broadcasting() {
            return (this.isStarted && this.isProviderForIframe) || this.isNow;
        }

        get broadcastQue() {
            return this.$store.state.backgroundView.broadcastQue;
        }

        get partner() {
            return this.element?.partnerId ? this.programDataHelper?.exhibitions?.find((partner) => partner.id === this.element?.partnerId) : null
        }

        get showSessionInfo() {
            return this.element && !this.isLoading && !this.hideSessionInfo;
        }

        get webConferenceState(): WebConferenceState {
            return this.$store.state.webConference;
        }

        get showLeave() {
            return (
                !this.isWebConf && !this.isLoading ||
                (
                    this.webConferenceState.stateHelper?.showDeviceTest || this.webConferenceState.stateHelper?.showEventInfo
                )
            )
        }

        async loadSessionData() {
            try {
                await this.dataHelper?.setObjectId(this.sessionId);
                this.dataHelper?.fetchSupportingData();
                await this.dataHelper?.fetchWebinarInfo();
                await this.checkBroadcast(this.isNow);
            }
            catch (e) {
                this.$store.dispatch('reportError', e);
            }
            finally {
                this.isLoading = false;
            }
        }

        async checkBroadcast(isLive: boolean) {
            if(isLive) {
                const broadcastIsBusy = BackgroundViewHelper.checkBroadcastIsBusy(this.broadcastQue);

                if(broadcastIsBusy) {

                    const confirmed = await BackgroundViewHelper.doConfirmModal();

                    if(confirmed && confirmed !== "close") {
                        this.$emit('liveConfirmed', true);
                        this.setVideoController();
                        this.showContactsArgreement = true;
                    }
                    else {

                        if(BackgroundViewHelper.getActiveBroadcastView(this.broadcastQue) === BackgroundViewName.session) {
                            this.$store.dispatch("backgroundView/setOffline", BackgroundViewName.session);
                        }
                        else {
                            this.$emit('liveConfirmed', false);
                        }

                        if(this.$route.meta?.from?.name !== "ViewSession") {

                            this.$emit('updateSessionId', this.prevSessionId);
                            this.$nextTick(() => {
                                this.$store.dispatch("miniPlayer/setShowPlayer", true);
                            })
                        }

                        this.$router.back();
                    }
                }
                else {
                    this.$emit('liveConfirmed', true);
                    this.setVideoController();
                }
            }
        }

        close() {
            this.$store.dispatch('onlineUsers/removeActivity', this.onlineUsersCounterId);
            this.$emit('close');
        }

        closeToStage() {
            this.allToStage = true;
            if(this.isAdmin && this.element) {
                this.sessionManipulationService?.completeSession(this.element?.id);
            }
        }

        /**
         * действия после окончания сессии по времени
         */
        public endSessionByTime() {
            //не ручное управление
            if(!this.isManualControlled || (this.isClosed && !this.isAdmin)) {
                this.doAfterSession();
            }
        }

        /**
         * действие после окончания сессии
         */
        private doAfterSession() {

            if(this.nextSession) {
                //проверить сколько осталось до начала следующей сессии
                const beforeStartNextSession = secondsBeforeMoment(this.nextSession.beginAt);

                if(beforeStartNextSession <= COMINGSOON_PERIOD_IN_MINUTES * 60) {
                    //если до начала меньше 5 минут то переход на эту сессию
                    this.startRedirect();
                    return;
                }
            }

            //если нет следующей или больше 5 минут то переход на прогрмму
            this.startRedirect();
        }

        /**
         * действия в момент начала сессии по времени
         */
        public async startSessionByTime() {
            const delay = Math.round((Math.random() * 4000));
            //delay for preventing waterfall requests to backend
            setTimeout(async () => {

                if(!this.element) {return;}

                if (!this.streamIframeSettings?.url) {
                    await this.loadSessionData();
                } else {
                    this.dataHelper!.element = new ElementModel(this.element);
                    !this.isSpeakerOrAdmin && await this.checkBroadcast(this.isNow);
                }

                this.loaded();
                this.$nextTick(() => this.initializeVideo())

            }, delay);
        }

        changeSession(id: string) {
            this.moveToSessionById(id);
        }

        loaded() {
            this.sendAnalytics(this.dataHelper?.element);
            this.$store.dispatch("setPageTitle", this.dataHelper?.element?.title);
        }

        onNewComment() {
            this.$emit('newComment', this.dataHelper?.objectId);
            if (this.dataHelper) {
                this.dataHelper.commentsCount++;
            }
        }

        selectProfile(user: UserProfile) {
            this.$emit('showProfile', user.userId);
        }

        sendAnalytics(element?: ElementModel) {
            if(element) {
                const originalDate = dateInOriginalOffset(DateTime.fromISO(element.beginAt), this.$store.state.timeZoneOffset);
                const timeAndTitle = `${originalDate.toFormat('dd.MM.yyyy H:mm')} ${element.title}`;
                this.sendScreenView(`Session - ${timeAndTitle}`, element.id, "Agenda");
            }
        }

        async likeChanged(value: number|null) {

            this.dataHelper?.updateLike(value);

            this.setLikes(value);

            EventBus.$emit('likeChanged', {
                id: this.dataHelper?.objectId,
                value
            });
        }

        @Debounce(500)
        setLikes(value: number|null) {
            this.dataHelper?.setLike(value);
        }

        resizeHandler() {
            this.updateCommetsVisibility();
            this.keepVideoRation();
        }

        /**
         * comments always must shown if screen is desktop
         */
        updateCommetsVisibility() {
            this.commentsMustShown = !detectMob();
        }

        keepVideoRation() {
            let frame = document.querySelector('.plyr__video-wrapper iframe') as HTMLElement;
            if(frame) {
                let parent = frame.parentElement as HTMLElement;
                let fixContainer = this.$refs["video-fix-container"] as HTMLElement;

                if(fixContainer) {
                    fixContainer.style.padding = getPaddingForCorrectRatio(fixContainer)
                }

                const scaleHeight = fixContainer.clientHeight / frame.clientHeight;
                const scaleWidth = fixContainer.clientWidth/ frame.clientWidth
                const scaleMin = Math.min(scaleHeight, scaleWidth);
                if(parent && ((fixContainer.clientHeight >= parent.clientHeight))) {
                    this.fixPlayerHeight = false;
                    frame.style.transform = `scale(${scaleMin})`;
                    frame.style.left = `0`
                } else {
                    this.fixPlayerHeight = true;
                }
            }
            else {
                console.warn("iframe not exist");
            }
        }

        getEdgeSize(edgeSize: number, ratio: number) {
            return edgeSize * ratio;
        }

        destroyed() {
            this.disconnectFromHub();
        }

        showVideoInfo() {
            if (this.plyr) {(this.plyr as any).embed?.showVideoInfo();}
        }

        hideVideoInfo() {
            if (this.plyr) {(this.plyr as any).embed?.hideVideoInfo();}
        }
    }
